import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  Section,
  Container,
  Grid,
  Col,
  Flex,
  SectionHeader,
  SanityBlockContent,
} from '../../common';
import { getIcon } from '../../../utils';

// const StyledTestimonial = styled.div`
//   background-color: ${(props) => props.$bgColor};
//   color: ${(props) => props.$color};
//   svg {
//     color: ${(props) => props.$svgColor};
//   }
// `;

const StyledTestimonial = styled.div`
  background-color: ${(props) => props.$bgColor};
  color: ${(props) => props.$color};
  svg {
    color: ${(props) => props.$svgColor};
  }
`;
const Testimonials = ({ sanity, page, section }) => {
  const { colors } = sanity;

  return (
    <Section
      idName="testimonials"
      bgColor={colors?.neutral?.lighter}
      h2Color={colors?.neutral?.darker}
    >
      <Container
        padding="none"
        classes="max-w-md px-4 text-center sm:max-w-3xl lg:max-w-7xl"
        inViewConfigRootMargin="1500px"
      >
        <SectionHeader
          sanity={sanity}
          tagline={section?.header?.tagline}
          headline={section?.header?.headline}
          description={section?.header?._rawDescription}
        />
        <Grid classes="lg:grid-cols-3 gap-y-8 lg:gap-24 max-w-7xl mx-auto lg:mx-0">
          {section?.testimonials?.map((testimonial, index) => (
            <Col classes="space-y-12 p-4 lg:p-0 text-left">
              <div className="relative h-full">
                <StyledTestimonial
                  $bgColor={colors?.primary?.default}
                  $color={colors?.accent?.lighter}
                  $svgColor={colors?.accent?.lighter}
                  className="z-10 h-full overflow-hidden rounded-2xl p-8 opacity-90 shadow-2xl lg:p-10"
                >
                  <svg
                    className="absolute left-3 top-3 h-16 w-16 opacity-50 lg:left-5 lg:top-5"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 144 144"
                    aria-hidden="true"
                  >
                    <path
                      strokeWidth={2}
                      d="M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z"
                    />
                  </svg>
                  <blockquote className="relative">
                    <div className="text-2xl font-light italic text-zinc-100">
                      <SanityBlockContent
                        sanity={sanity}
                        blocks={testimonial?._rawQuote}
                      />{' '}
                    </div>
                    <footer className="mt-8">
                      <Grid classes="grid-cols-12 gap-x-8 lg:gap-x-8 content-center">
                        <div className="col-span-2 h-12 w-12 rounded-full">
                          <GatsbyImage
                            image={
                              testimonial?.portrait?.asset?.gatsbyImageData
                            }
                            alt={testimonial?.portrait?.alt}
                            className="h-full w-full rounded-full object-cover"
                          />
                        </div>
                        <div className="col-span-10 flex flex-col justify-center">
                          <div className="text-base font-bold lg:text-lg">
                            {testimonial?.author}
                          </div>
                          <div className="text-base text-white lg:text-lg">
                            {testimonial?.jobTitle}
                          </div>
                          <div className="text-base text-white lg:text-lg">
                            {testimonial?.company}
                          </div>
                          <div className="text-base text-white lg:text-lg">
                            {testimonial?.location}
                          </div>
                          <Flex classes="text-base lg:text-lg font-medium pt-2">
                            {Array(5)
                              .fill()
                              .map((_, i) => {
                                const StarIconComponent = getIcon('Star');
                                return (
                                  <StarIconComponent
                                    key={i}
                                    className="!text-yellow-500"
                                  />
                                );
                              })}
                          </Flex>
                        </div>
                      </Grid>
                    </footer>
                  </blockquote>
                </StyledTestimonial>
              </div>
            </Col>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export { Testimonials };
